<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <div class="buying-strategy">
    <div
      v-if="useReadOnlyMode"
      class="read-only">
      <!--      <h4>{{ capitalize($t('messages.buyingStrategy')) }}</h4>-->
      <!--      <div v-if="selectedBuyingStrategy != null" class="flex-h">-->
      <!--        <component :is="selectedBuyingStrategy.icon"-->
      <!--                   class="mr-3"></component>-->
      <!--        <div class="flex-v">-->
      <!--          {{ selectedBuyingStrategy.name }}-->
      <!--          <span class="text-muted">{{ selectedBuyingStrategy.description }}</span>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
    <div v-else>
      <!--      <div class="form-group row">-->
      <!--        <div class="col-sm-12">-->
      <!--          <selectable-tiles :items="pricingStrategies"-->
      <!--                            :should-display-labels="true"-->
      <!--                            :should-display-icons="true"-->
      <!--                            :should-display-checkmark-on-selected-items="true"-->
      <!--                            label-property-name="name"-->
      <!--                            tooltip-property-name="description"-->
      <!--                            icon-property-name="icon"-->
      <!--                            icon-size="4.8rem"-->
      <!--                            :selected-items="selectedBuyingStrategy == null ? [] : [selectedBuyingStrategy]"-->
      <!--                            :is-multiselect="false"-->
      <!--                            :allow-empty="false"-->
      <!--                            :justify-content-left="false"-->
      <!--                            tile-width="25%"-->
      <!--                            min-tile-width="10rem"-->
      <!--                            tile-padding="1.6rem 1rem 1rem"-->
      <!--                            v-on:selectionChanged="(val) => { pricingStrategy = val[0].id }"></selectable-tiles>-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="form-group row">
        <div class="col-12">
          <div class="chart-pane-header">
            <!--            {{ capitalize($t('names.maxBidCPM', { n: 1 })) }}-->
            Impressions per max bid
          </div>
        </div>
        <div class="col-sm-12">
          <div class="chart-pane">
            <slider-chart
              :datapoints="maxBidCPMData"
              :value="maxBidCPM"
              :markers="maxBidCPMMarkers"
              :y-axis="{
                label: 'Available Impressions',
                formatter: (x) => formatNumber((estimatedTotalImpressions / rateMultiplier) * x, '0.0a'),
                hidden: false,
              }"
              :y-tooltip="{ label: 'Bid Win %', hidden: true }"
              chart-height="30rem"
              :chart-padding-left="100"
              @change="onMaxBidCPMSliderChange" />
            <div class="kpis">
              <div class="kpi has-gauge">
                <!--                <chart v-if="gaugeOptions != null"-->
                <!--                       ref="chart"-->
                <!--                       :options="gaugeOptions"-->
                <!--                       theme="hs-historical-bids"-->
                <!--                       auto-resize></chart>-->
                <!-- COMMENTED BECAUSE OF VUE3 ERRORS -->
                <!--                <vue-svg-gauge :start-angle="-110"-->
                <!--                               :end-angle="110"-->
                <!--                               :value="0"-->
                <!--                               :separator-step="0.25"-->
                <!--                               :separator-thickness="1"-->
                <!--                               :min="0"-->
                <!--                               :max="1"-->
                <!--                               base-color="#ccc"-->
                <!--                               :scale-interval="0.1"/>-->
                <!--                <vue-svg-gauge :start-angle="-110"-->
                <!--                               :end-angle="110"-->
                <!--                               :value="forecastedBidWinRate"-->
                <!--                               :separator-step="0.25"-->
                <!--                               :separator-thickness="1"-->
                <!--                               :min="0"-->
                <!--                               :max="1"-->
                <!--                               base-color="#ddd"-->
                <!--                               :gauge-color="[-->
                <!--                                 { offset: 0, color: '#FF0083' },-->
                <!--                                  { offset: 100, color: '#FF008399'},-->
                <!--                                  ]"-->
                <!--                               :scale-interval="0.1"-->
                <!--                />-->

                <div class="value">{{ forecastedWinRateFormatted }}</div>
                <div class="label">Forecasted Bid Win Rate</div>
              </div>
              <div class="kpi">
                <div class="value">{{ maxBidCPMFormatted }}</div>
                <div class="label">Max Bid CPM</div>
              </div>
              <div class="kpi">
                <div class="value">{{ forecastedImpressionsFormatted }}</div>
                <div class="label">Forecasted Impressions</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-12">
          <div class="chart-pane-header">
            {{ capitalize($t('messages.historicalAndForecastedBidCPM', { n: 1 })) }}
          </div>
        </div>
        <div class="col-sm-12">
          <div class="chart-pane">
            <historical-bid-chart
              :line-item="lineItem"
              :recommended-c-p-m="maxBidCPM != null ? maxBidCPM.x : recommendedCPM"
              @bid-data-changed="(val) => (bidData = val)" />
          </div>
        </div>
        <!--        <div class="col-12">-->
        <!--          <div class="chart-pane-header">-->
        <!--            {{ capitalize($t('messages.maxFloorCPMIncrease')) }} %-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <div class="col-sm-12">-->
        <!--          <div class="chart-pane">-->
        <!--            <slider-chart :datapoints="maxFloorCPMIncreaseData"-->
        <!--                          :value="maxFloorCPMIncrease"-->
        <!--                          :markers="[{ value: 0.155, color: '#888', label: 'Suggested' }]"-->
        <!--                          :y-tooltip="{ label: 'win rate', hidden: true }"-->
        <!--                          x-formatter="%0"-->
        <!--                          chart-height="30rem"-->
        <!--                          :chart-padding-left="32"-->
        <!--                          @change="onMaxFloorCPMIncreaseSliderChange"></slider-chart>-->
        <!--            <div class="kpi">-->
        <!--              <div class="value">{{ forecastedWinRateFormatted }}</div>-->
        <!--              <div class="label">Forecasted Win %</div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
      <!--      <div class="form-group row">-->
      <!--        <div class="col-12">-->
      <!--          <div class="chart-pane-header">-->
      <!--            {{ capitalize($t('messages.forecastedBidGeoDistribution', { n: 1 })) }}-->
      <!--          </div>-->
      <!--        </div>-->
      <!--        <div class="col-sm-12">-->
      <!--          <div class="chart-pane">-->
      <!--            <bid-geo-distribution :start-date="lineItem.startDate == null ? DateTime.local().startOf('day') : DateTime.fromISO(lineItem.startDate)"-->
      <!--                                  :line-item="lineItem"-->
      <!--                                  :bid-data="bidData"-->
      <!--                                  :unit-ids="unitIds"></bid-geo-distribution>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="form-group row">
        <div class="col-12">
          <div class="chart-pane-header">
            {{ $t('messages.biddingAgent') }}
          </div>
        </div>
        <div class="col-sm-12">
          <div class="chart-pane">
            <autopilot-overrides
              :line-item="lineItem"
              @selected-buying-strategy-changed="onSelectedBuyingStrategyChanged" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import { DateTime } from 'luxon';
  import { capitalize, markRaw } from 'vue';
  import { mapActions } from 'vuex';

  import Colors from '@/Colors';
  import { SliderChart } from '@/common/components/controls';
  import { IconColoredBuyingStrategyFixed, IconColoredTrueBid } from '@/common/icons/colored';
  import { DASH } from '@/globals';
  import AutopilotOverrides from '@/org-app/components/lineItems/form/AutopilotOverrides';
  import HistoricalBidChart from '@/org-app/components/lineItems/form/HistoricalBidChart';
  import LocalCache from '@/utils/LocalCache';
  import formatNumber from '@/utils/NumberFormatter';
  import i18n from '@/vueI18n';

  export default {
    components: {
      AutopilotOverrides,
      HistoricalBidChart,
      SliderChart,
      // VueSvgGauge,
    },
    props: {
      lineItem: {
        type: Object,
      },
      useReadOnlyMode: {
        type: Boolean,
        default: false,
      },
      targetedImpressions: {
        type: Number,
        default: 0,
      },
      estimatedTotalImpressions: {
        type: Number,
        default: 40000000,
      },
      unitIds: {
        type: Array,
        default: () => [],
      },
      recommendedCPM: {
        type: Number,
        default: null,
      },
    },
    data() {
      return {
        bidData: null,
        estimatedImpressions: 0,
        maxBidCPMData: [],
        maxFloorCPMIncreaseData: [],
        maxBidCPM: null,
        maxBidCPMMarkers: [],
        maxFloorCPMIncrease: null,
        rateMultiplier: 1.5,
        selectedBuyingStrategy: null,
        Colors,
        DateTime,
      };
    },
    computed: {
      bidsByLocation() {
        return [];
      },
      pricingStrategy: {
        get() {
          return this.lineItem !== null ? this.lineItem.deliveryCurve : null;
        },
        set(value) {
          if (this.lineItem === null || this.lineItem === undefined) {
            return;
          }
          const lineItemID = `LI ${this.lineItem.id}`;
          const data = LocalCache.get('lineItemPricingStrategy');
          let lineItemPricingStrategy = null;
          if (data == null) {
            lineItemPricingStrategy = {};
          } else {
            lineItemPricingStrategy = JSON.parse(data);
          }
          if (lineItemPricingStrategy[lineItemID] == null) {
            lineItemPricingStrategy[lineItemID] = {};
          }
          lineItemPricingStrategy[lineItemID].pricingStrategy = value;
          LocalCache.set('lineItemPricingStrategy', lineItemPricingStrategy);
        },
      },
      pricingStrategies() {
        return [
          {
            id: 'optimized',
            name: capitalize(i18n.global.t('messages.buyingStrategyTrueBid')),
            description: capitalize(i18n.global.t('messages.buyingStrategyOptimizedCPM')),
            icon: markRaw(IconColoredTrueBid),
          },
          {
            id: 'fixed',
            name: capitalize(i18n.global.t('messages.buyingStrategyFixedCPM')),
            // description: capitalize(i18n.global.t('messages.buyingStrategyEvenDescription')),
            icon: markRaw(IconColoredBuyingStrategyFixed),
          },
        ];
      },
      selectedPricingStrategies() {
        if (this.pricingStrategy == null) {
          return this.pricingStrategies[0];
        }
        return this.pricingStrategies.find((x) => x.id === this.pricingStrategy);
      },
      forecastedImpressions() {
        if (
          this.maxBidCPM == null ||
          this.targetedImpressions == null ||
          this.maxBidCPMData.length === 0 ||
          this.targetedImpressions === Number.POSITIVE_INFINITY
        ) {
          return 0;
        }
        return Math.min(this.targetedImpressions, this.rateMultiplier * this.targetedImpressions * this.maxBidCPM.y);
      },
      forecastedImpressionsFormatted() {
        if (this.maxBidCPM == null || this.targetedImpressions == null || this.maxBidCPMData.length === 0) {
          return DASH;
        }
        return formatNumber(this.forecastedImpressions, '0.0a');
      },
      forecastedBidWinRate() {
        if (this.forecastedImpressions === 0) {
          return 0;
        }
        return this.maxBidCPM.y;
      },
      forecastedWinRateFormatted() {
        if (this.forecastedBidWinRate == null) {
          return DASH;
        }
        return formatNumber(this.forecastedBidWinRate, '%0.0');
      },
      maxBidCPMFormatted() {
        if (this.maxBidCPM == null) {
          return DASH;
        }
        return formatNumber(this.maxBidCPM.x, '$0,0.00');
      },
      // gaugeOptions() {
      //   const vGradient = new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      //     offset: 0,
      //     color: '#c1dbff',
      //   }, {
      //     offset: 1,
      //     color: '#d7e8ff',
      //   }]);
      //
      //   return {
      //     series: [
      //       {
      //         // name: '业务指标',
      //         type: 'gauge',
      //         detail: { formatter: '{value}%' },
      //         data: [{
      //           value: Math.round(this.forecastedBidWinRate * 1000) / 10,
      //           name: 'forecasted bid win rate',
      //         }],
      //         itemStyle: {
      //           color: vGradient,
      //           color0: vGradient,
      //           borderColor: '#9bb0cc99',
      //           borderColor0: '#9bb0cc99',
      //           shadowColor: '#00000033',
      //           shadowBlur: 2,
      //           shadowOffsetY: 2,
      //         },
      //       },
      //     ],
      //   };
      // },
    },
    methods: {
      capitalize,
      ...mapActions(['updateLineItemDeliveryCurve']),
      formatNumber,
      handleBuyingStrategyUpdated(value) {
        this.$emit('changed', value);
      },
      onMaxBidCPMSliderChange(value) {
        this.maxBidCPM = value;
        this.fireChangeEvents();
      },
      onMaxFloorCPMIncreaseSliderChange(value) {
        this.maxFloorCPMIncrease = value;
        this.$emit('maxFloorCPMIncreaseChanged', this.maxFloorCPMIncrease.y);
      },
      onSelectedBuyingStrategyChanged() {
        // console.log(bs);
      },
      computeCPMData() {
        if (this.recommendedCPM == null) {
          return;
        }
        // Max bid CPM data
        let maxBidCPMData = [];
        const maxCPM = this.rateMultiplier * this.recommendedCPM;
        const cpmStep = 0.1;
        const dataPoints = maxCPM / cpmStep;

        let lastRate = 150;
        let count = 0;
        for (let i = maxCPM; i > 0; i -= cpmStep) {
          const rate = Math.max(0, Math.min(lastRate, 100 - (100 / dataPoints) * ((Math.random() - 0.5) * 2 * count)));
          maxBidCPMData.push({ x: Math.round(i * 100) / 100, y: rate });
          lastRate = rate;
          count += 1;
        }

        maxBidCPMData = maxBidCPMData
          .reverse()
          .filter((x) => x.y > 0)
          .map((dp) => ({ x: dp.x, y: dp.y / 100 }));
        this.maxBidCPMData = maxBidCPMData;
        let cpm = { x: 0 };
        let ci = 0;
        while (cpm.x < this.recommendedCPM && maxBidCPMData.length > ci) {
          cpm = maxBidCPMData[ci];
          ci += 1;
        }
        this.maxBidCPM = cpm;
        this.fireChangeEvents();
        this.maxBidCPMMarkers = [{ value: cpm.x, color: '#888', label: 'Suggested' }];

        // Max bid CPM data
        let maxFloorCPMIncreaseData = [];
        const maxIncrease = Math.random() * 100 + 50;
        const increaseStep = 1;
        // const increaseDataPoints = maxIncrease / increaseStep;

        const easeOutQuint = (t) => 1 + --t * t * t * t * t;

        let lastIncrease = 0;
        count = 0;
        for (let i = 0; i < maxIncrease; i += increaseStep) {
          let increase = easeOutQuint(0.1 + i / maxIncrease) + (Math.random() - 0.5) * 0.05;
          increase = Math.max(lastIncrease, increase);
          maxFloorCPMIncreaseData.push({
            x: Math.round(i * 100) / 100,
            y: increase,
          });
          lastIncrease = increase;
          count += 1;
        }

        maxFloorCPMIncreaseData = maxFloorCPMIncreaseData
          .filter((dp) => dp.y <= 1)
          .map((dp) => ({ x: dp.x / 100, y: dp.y }));
        this.maxFloorCPMIncreaseData = maxFloorCPMIncreaseData;
        this.maxFloorCPMIncrease = maxFloorCPMIncreaseData[Math.floor(Math.random() * maxFloorCPMIncreaseData.length)];
      },
      fireChangeEvents() {
        this.$emit('forecastedImpressionsChanged', this.forecastedImpressions);
        this.$emit('forecastedBidWinRateChanged', this.forecastedBidWinRate);
      },
    },
    watch: {
      recommendedCPM() {
        if (this.recommendedCPMTimer) {
          clearTimeout(this.recommendedCPMTimer);
        }

        this.recommendedCPMTimer = setTimeout(() => {
          this.recommendedCPMTimer = null;
          this.computeCPMData();
        }, 200);
      },
      targetedImpressions() {
        this.fireChangeEvents();
      },
    },
    beforeMount() {
      this.computeCPMData();
      [this.selectedBuyingStrategy] = this.pricingStrategies;
    },
    mounted() {
      this.$emit('ready');
    },
  };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use 'sass:color';
  @use '@/styles/variables.scss' as *;

  .buying-strategy {
    .read-only {
      svg {
        width: 4rem;
        height: 4rem;
      }
    }
  }

  .chart-pane {
    overflow: hidden;
    border: solid 0.1rem $borders;
    border-radius: 0.8rem;
    box-shadow: $small-shadow;
    display: flex;
    align-items: center;
    background: #fdfdfd;

    .kpis {
      border-left: solid 0.1rem $borders;
      flex-direction: column;

      .kpi {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 21rem;
        position: relative;

        .value {
          font-size: 2.4rem;
          font-weight: 700;
        }

        .label {
          text-align: center;
          text-transform: uppercase;
          font-weight: 600;
          font-size: 1.2rem;
          margin-bottom: 1rem;

          color: var(--textMutedColor);
        }

        .gauge {
          width: 16rem;
          position: relative;
          top: 0.9rem;
          margin-bottom: -4rem;

          &:first-of-type {
            position: absolute;
            top: -1.2rem;
            opacity: 1;
            filter: blur(7px);
          }
        }

        &.has-gauge {
          .value {
            margin-bottom: 2rem;
          }

          .label {
            margin-bottom: 1rem;
          }
        }
      }
    }
  }

  .chart-pane-header {
    margin-top: 1.6rem;
    margin-bottom: 0.3rem;
    font-weight: 900;
  }
</style>
